import { View } from 'react-native';

import type { Toll } from '@/api';
import { GREY_40 } from '@/style/colors';
import { Card, Text } from '@/ui';

export default function TollCard({
  toll,
  showAdminFee = true,
  costType = 'partner',
}: {
  toll: Toll;
  showAdminFee?: boolean;
  costType?: 'customer' | 'partner';
}) {
  const displayedCost =
    costType === 'customer' ? toll.amount : toll.adminAmount;

  return (
    <Card style={{ gap: 8, padding: 16 }}>
      <View>
        <Text tx="tolls.location" type="caption1" style={{ color: GREY_40 }} />

        <Text type="bodyRegular">{toll.name}</Text>
      </View>

      <View>
        <Text tx="tolls.time" type="caption1" style={{ color: GREY_40 }} />

        <Text type="bodyRegular">{toll.date}</Text>
      </View>

      <View>
        <Text tx="tolls.cost" type="caption1" style={{ color: GREY_40 }} />

        <Text type="bodyRegular">{`$${displayedCost}`}</Text>
      </View>

      {showAdminFee ? (
        <View>
          <Text
            tx="tolls.processingFee"
            type="caption1"
            style={{ color: GREY_40 }}
          />

          <Text type="bodyRegular">{`$${toll.adminFee}`}</Text>
        </View>
      ) : null}
    </Card>
  );
}
